<mat-slider [max]="max"
            [min]="min"
            [step]="step"
            [discrete]="true"
            [displayWith]="displayWith">
  <input matSliderThumb [value]="value" (valueChange)="onValueChange($event)">
</mat-slider>
